export enum stepActionTypes {
  INCREMENT = ' INCREMENT',
  DECREMENT = 'DECREMENT',
}
